export const STATIONARY_TIME = 'StationaryTime';
